import React, {memo, useLayoutEffect, useRef} from 'react';
import s from "./PhoneCodesInput.module.css";
import "./index.css"
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import {useField} from "formik";
import classnames from "classnames";

type CountryData = {
    name: string;
    iso2: string;
    dialCode: string;
    format?: string;
    hasAreaCodes?: boolean;
}

type propsType = {
    initCode?: any,
    phonecodes?: any,
    value?: string,
    onChange?: any,
    setCode?: any,
    error?: any,
    id?: any,
    name?: any,
    touched?: any,
    selectable?: boolean,
    onlyCountries?: string[]
    recipientCountry?: string[]
    onCountryChange?: (countryData: CountryData) => void
    onCountryCodeChange?: (countryClient: string) => void
}

const PhoneCodesInput = memo((props: propsType) => {

    const phoneInputElement = useRef<any>(null);
    const [field, , helpers] = useField(props.name);
    const [countryField, , countryHelpers] = useField('countryClient');
    const {setValue} = helpers;
    const {setValue: setCountryValue} = countryHelpers;

    useLayoutEffect(() => {
        setValue('');
        setCountryValue('');
    }, [props.recipientCountry, setValue, setCountryValue]);

    const onHandleChangePhone = (isValid: boolean, value: string, selectedCountryData: any, fullNumber: string, extension: string) => {
        phoneInputElement.current?.tel.focus();

        // Обновляем номер телефона
        if (field.value !== fullNumber) {
            setTimeout(() => {
                phoneInputElement.current?.tel.setSelectionRange(fullNumber.length, fullNumber.length);
            }, 0);
            setValue(fullNumber);
        }

        // Обновляем данные страны - сохраняем ПОЛНОЕ название страны
        if (selectedCountryData && selectedCountryData.iso2) {
            // selectedCountryData.name содержит полное название страны (например "United States")
            const countryInfo = {
                name: selectedCountryData.name,  // Полное название страны
                iso2: selectedCountryData.iso2.toUpperCase(),
                dialCode: selectedCountryData.dialCode,
                format: selectedCountryData.format
            };

            // Сохраняем полное название страны в Formik
            setCountryValue(countryInfo.name);  // Теперь сохраняем название, а не код

            // Вызываем оба callback для гибкости
            if (props.onCountryChange) {
                props.onCountryChange(countryInfo);
            }
            if (props.onCountryCodeChange) {
                props.onCountryCodeChange(countryInfo.name);
            }
        }
    };

    return (
        <div className={s.input_name_block}>
            <IntlTelInput
                onPhoneNumberChange={onHandleChangePhone}
                containerClassName="intl-tel-input"
                inputClassName={classnames('iti__tel-input', props.error && 'iti__tel-input-error')}
                value={field.value}
                formatOnInit={true}
                autoHideDialCode={true}
                autoPlaceholder={false}
                ref={phoneInputElement}
                onlyCountries={props.onlyCountries || undefined}
                preferredCountries={props.onlyCountries || ['ca']}
            />
        </div>
    );
});

export default PhoneCodesInput;